import { render, staticRenderFns } from "./edc-submitted-unscheduled-packets.vue?vue&type=template&id=fd130c1c&scoped=true&"
import script from "./edc-submitted-unscheduled-packets.vue?vue&type=script&lang=js&"
export * from "./edc-submitted-unscheduled-packets.vue?vue&type=script&lang=js&"
import style0 from "./edc-submitted-unscheduled-packets.vue?vue&type=style&index=0&id=fd130c1c&scoped=true&lang=scss&"
import style1 from "./edc-submitted-unscheduled-packets.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd130c1c",
  null
  
)

component.options.__file = "edc-submitted-unscheduled-packets.vue"
export default component.exports